import { apiPost } from './api';

export const storeTransaction = async (params: any) => {
  const body = {
    action: 'create_transaction',
    ...params,
  };
  const { data } = await apiPost(body);
  return data;
};

export const requestOtp = async () => {
  const body = {
    action: 'request_otp',
  };
  const { data } = await apiPost(body);
  return data;
};

export const storeTransfer = async (params: any) => {
  const body = {
    action: 'create_transfer_points',
    ...params,
  };
  const { data } = await apiPost(body);
  return data;
};
